// This file is auto-generated by running `yarn svg:process`

import * as React from 'react'

export const IconLinkSvg = (
  props: React.SVGProps<SVGSVGElement>,
): React.ReactElement => {
  return (
    <svg
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      height={props.height ? +props.height * (4 / 3) : props.height}
      width={props.width ? +props.width * (4 / 3) : props.width}
      fill={props.fill}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.586 9.707a2 2 0 012.828 0l1.879 1.879a2 2 0 010 2.828l-1.94 1.94-.707-.708 1.94-1.94a1 1 0 000-1.413l-1.88-1.879a1 1 0 00-1.413 0l-3.879 3.879a1 1 0 000 1.414l1.44 1.44-.708.706-1.44-1.439a2 2 0 010-2.828l3.88-3.88v.001zm0 6.586l-1.44-1.44.707-.707 1.44 1.44a2 2 0 010 2.828l-3.879 3.879a2 2 0 01-2.828 0l-1.88-1.879a2 2 0 010-2.828l1.94-1.94.707.707-1.939 1.94a1 1 0 000 1.414l1.879 1.879a1 1 0 001.414 0l3.879-3.88a1 1 0 000-1.413z"
      />
    </svg>
  )
}
